// extracted by mini-css-extract-plugin
export default {"tabs-nav":"color-powder_tabs-nav__sqEzA","tabs-tab":"color-powder_tabs-tab__fhT18","active":"color-powder_active__9MNlT"};